
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AccessTokenGenerationRequest,
  AccessTokenResource,
  AccessTokenType,
  GeneratedAccessTokenResource,
} from '../models';
import {
    AccessTokenGenerationRequestFromJSON,
    AccessTokenGenerationRequestToJSON,
    AccessTokenResourceFromJSON,
    AccessTokenResourceToJSON,
    AccessTokenTypeFromJSON,
    AccessTokenTypeToJSON,
    GeneratedAccessTokenResourceFromJSON,
    GeneratedAccessTokenResourceToJSON,
} from '../models';

export interface DeleteAccessTokenRequest {
    tokenId: string;
}

export interface GetAccessTokensByIdRequest {
    tokenId: string;
}

export interface PostAccessTokenRequest {
    accessTokenGenerationRequest: AccessTokenGenerationRequest;
}

/**
 * 
 */
export class AccessTokenApi extends runtime.BaseAPI {

    /**
          */
    async deleteAccessTokenRaw(requestParameters: DeleteAccessTokenRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['tokenId'] == null) {
            throw new runtime.RequiredError(
                'tokenId',
                'Required parameter "tokenId" was null or undefined when calling deleteAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/access-tokens/{tokenId}`.replace(`{${"tokenId"}}`, encodeURIComponent(String(requestParameters['tokenId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async deleteAccessToken(requestParameters: DeleteAccessTokenRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccessTokenRaw(requestParameters, initOverrides);
    }

    /**
          */
    async getAccessTokensRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AccessTokenResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<AccessTokenResource>>({
            path: `/account/api/access-tokens`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(AccessTokenResourceFromJSON);
        return response;
    }

    /**
          */
    async getAccessTokens(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AccessTokenResource>> {
        const response = await this.getAccessTokensRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getAccessTokensByIdRaw(requestParameters: GetAccessTokensByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AccessTokenResource>> {
        if (requestParameters['tokenId'] == null) {
            throw new runtime.RequiredError(
                'tokenId',
                'Required parameter "tokenId" was null or undefined when calling getAccessTokensById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AccessTokenResource>({
            path: `/account/api/access-tokens/{tokenId}`.replace(`{${"tokenId"}}`, encodeURIComponent(String(requestParameters['tokenId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AccessTokenResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getAccessTokensById(requestParameters: GetAccessTokensByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AccessTokenResource> {
        const response = await this.getAccessTokensByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve accessible token types for current user
          */
    async getTokenTypesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<AccessTokenType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<AccessTokenType>>({
            path: `/account/api/access-tokens/type`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(AccessTokenTypeFromJSON);
        return response;
    }

    /**
     * Retrieve accessible token types for current user
          */
    async getTokenTypes(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<AccessTokenType>> {
        const response = await this.getTokenTypesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async postAccessTokenRaw(requestParameters: PostAccessTokenRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<GeneratedAccessTokenResource>> {
        if (requestParameters['accessTokenGenerationRequest'] == null) {
            throw new runtime.RequiredError(
                'accessTokenGenerationRequest',
                'Required parameter "accessTokenGenerationRequest" was null or undefined when calling postAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<GeneratedAccessTokenResource>({
            path: `/account/api/access-tokens`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccessTokenGenerationRequestToJSON(requestParameters['accessTokenGenerationRequest']),
        }, initOverrides);

        if (response._data) { response._data=GeneratedAccessTokenResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async postAccessToken(requestParameters: PostAccessTokenRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<GeneratedAccessTokenResource> {
        const response = await this.postAccessTokenRaw(requestParameters, initOverrides);
        return response._data;
    }

}
